const useGetMappingByControl = () => {
 
  const getMappingByControl = (control, option="mapping") => { 
    
    if(control.properties.data && control.properties.data.option.toLowerCase() == option){
      
      return control.properties.data.value.mapping.values
              .filter(item => item.id == control.properties.data.value.mapping.id)[0]
    }
    return undefined
    
  }
  return getMappingByControl;
};

export default useGetMappingByControl;
